// extracted by mini-css-extract-plugin
module.exports = {"container":"container-module--container--1stMa"};